/*
 * @Author: qiu
 * @Date: 2021-05-13 11:07:16
 * @Last Modified by: qiu
 * @Last Modified time: 2021-05-13 14:49:45
 */
import apiList from './interface/index'
const install = Vue => {
  if (install.installed) {
    return
  }
  install.installed = true
  Object.defineProperty(Vue.prototype, '$apis', {
    get() {
      return apiList
    }
  })
}
export default install



// WEBPACK FOOTER //
// ./src/api/service.js